/* Favoritos — localStorage, sin apps externas ni cuenta de cliente.
 *
 * La lista es del NAVEGADOR, no del servidor: por eso la página de favoritos
 * no se puede pintar en Liquid y pide cada ficha con `?view=card`, que
 * devuelve la misma tarjeta que la colección.
 */
(function () {
  var KEY = 'fds_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: list } }));
  }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function resumen(n) {
    document.querySelectorAll('[data-wishlist-resumen]').forEach(function (el) {
      // Los dos textos vienen ya traducidos desde Liquid; aquí sólo se elige.
      el.textContent = n === 1
        ? el.getAttribute('data-uno')
        : (el.getAttribute('data-varios') || '').replace('__n__', n);
    });
  }

  function paint() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = list.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      // El rótulo cambia con el estado: un botón que siempre dice "Guardar en
      // favoritos" miente en cuanto ya está guardado, y el lector de pantalla
      // es lo único que tiene quien no ve el corazón relleno.
      var et = btn.getAttribute(active ? 'data-label-quitar' : 'data-label-guardar');
      if (et) btn.setAttribute('aria-label', et);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.style.display = list.length ? '' : 'none';
    });
    resumen(list.length);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-handle'));
    paint();
  });

  document.addEventListener('wishlist:change', paint);

  // Otra pestaña del mismo navegador también cambia la lista. Sin esto, el
  // contador de la cabecera se queda con lo que había al cargar la página.
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) paint();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();

  /* ---- Página de favoritos ---- */
  var grid = document.querySelector('[data-wishlist-grid]');
  if (!grid) return;

  var vacio = document.querySelector('[data-wishlist-empty]');
  var mostrarVacio = function (si) { if (vacio) vacio.hidden = !si; };

  var favs = read();
  if (!favs.length) { mostrarVacio(true); return; }

  Promise.all(favs.map(function (handle) {
    return fetch('/products/' + handle + '?view=card')
      .then(function (r) {
        return r.ok
          ? r.text().then(function (t) { return { handle: handle, html: t }; })
          : { handle: handle, html: null };
      })
      .catch(function () { return { handle: handle, html: null }; });
  })).then(function (fichas) {
    // UN FAVORITO QUE YA NO EXISTE SE CAE DE LA LISTA. Si el producto se retiró
    // o pasó a borrador, su ficha devuelve 404: antes se ignoraba en silencio y
    // el contador seguía diciendo "5 guardados" mientras se veían 3.
    var vivos = fichas.filter(function (f) { return f.html; });
    if (vivos.length !== favs.length) write(vivos.map(function (f) { return f.handle; }));

    vivos.forEach(function (f) { grid.insertAdjacentHTML('beforeend', f.html); });
    mostrarVacio(!vivos.length);
    paint();

    // Al quitar el corazón, la tarjeta se va en el momento: es su propia lista,
    // y dejarla ahí obliga a recargar para saber si se guardó el cambio.
    document.addEventListener('wishlist:change', function () {
      var l = read();
      grid.querySelectorAll('.product-card').forEach(function (card) {
        var btn = card.querySelector('[data-wishlist-toggle]');
        var h = btn && btn.getAttribute('data-handle');
        if (h && l.indexOf(h) === -1) card.remove();
      });
      mostrarVacio(!l.length);
    });
  });
})();
